<template>
  <div class="hotel-book mt40">
    <!-- 房间信息 -->
    <div class="room-info-outter">
      <div class="title">房间信息</div>
      <div class="content flex">
        <div class="left">
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="(item, index) in roomInfo.bannerList" :key="index">
              <img :src="item" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="right">
          <!-- 酒店信息 -->
          <div class="hotel-info">
            <div class="flex-start">
              <span class="hotel-name">{{hotelInfo.hotelName}}</span>
              <span class="hotel-type">{{hotelInfo.hotelLevel}}</span>
            </div>
            <div class="hotel-adr">
              <img src="../../assets/images/adr.png">
              <span>{{hotelInfo.addressDetails}}</span>
            </div>
          </div>
          <!-- 房型信息 -->
          <div class="room-info">
            <div class="room-name">{{roomInfo.name}}</div>
            <div class="facility mt10">
              <div class="block">
                <div>
                  <img src="../../assets/images/facility-icon1.png">
                  <span>{{roomInfo.usableArea || 0}}㎡</span>
                </div>
                <div>
                  <img src="../../assets/images/facility-icon2.png">
                  <span>{{roomInfo.onFloors || 0}}层</span>
                </div>
                <div>
                  <img src="../../assets/images/facility-icon3.png">
                  <span>{{roomInfo.windowsState}}</span>
                </div>
                <div>
                  <img src="../../assets/images/facility-icon4.png">
                  <span>{{roomInfo.breakfastState}}</span>
                </div>
              </div>
              <div class="block mt8">
                <div>
                  <img src="../../assets/images/facility-icon5.png">
                  <span>{{roomInfo.bedType}}</span>
                </div>
                <div>
                  <img src="../../assets/images/facility-icon6.png">
                  <span>{{roomInfo.maximumCapacity}}名成人</span>
                </div>
                <div>
                  <img src="../../assets/images/facility-icon7.png">
                  <span>{{roomInfo.addBedState}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 设施详情 -->
          <div class="facility-info">
            <div class="flex-align-baseline mt10" v-for="(item, index) in roomInfo.relatedFacilities" :key="index">
              <div class="facility-name">{{item.typename}}</div>
              <div class="facility-detail flex-1">{{item.valueStr}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 填写订单信息 -->
    <div class="order-info">
      <div class="title">填写订单信息</div>
      <!-- 预订信息 -->
      <div class="order-info-item flex-align-baseline">
        <div class="label">预订信息</div>
        <div class="content">
          <div class="mt40 flex-align-baseline">
            <span>入离日期</span>
            <div class="date-div">
              <div class="date-info">
                <span>入住</span>
                <span class="date">{{orderInfo.useStartDate}}</span>
                <span>{{startWeek}}</span>
                <img @click="handleShowDate('startDate')" src="../../assets/images/date-icon-green.png">
                <el-date-picker
                  class="hide-date"
                  popper-class="start-date"
                  ref="startDate"
                  v-model="orderInfo.useStartDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :picker-options="setStartDateDisabled"
                  @change="handleStartDate"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="m16">至</div>
            <div class="date-div">
              <div class="date-info">
                <span>离店</span>
                <span class="date">{{orderInfo.useEndDate}}</span>
                <span>{{endWeek}}</span>
                <img @click="handleShowDate('endDate')" src="../../assets/images/date-icon-green.png">
                <el-date-picker
                  class="hide-date"
                  popper-class="end-date"
                  ref="endDate"
                  v-model="orderInfo.useEndDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :picker-options="setEndDateDisabled"
                  @change="handleEndDate"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="staydays">共{{stayDays}}晚</div>
          </div>
          <div class="mt40 flex-align-baseline">
            <span>房间数量</span>
            <div class="room-num">
              <div class="num-div" v-for="(item, index) in 6" :key="index" :class="{ active: index+1 === orderInfo.quantity && !edit }" @click="handleRoomNum(index+1)">
                {{index+1}}
                <img v-if="index+1 === orderInfo.quantity && !edit" src="../../assets/images/selected-icon.png" alt="">
              </div>
              <div class="other num-div">
                <span v-if="!edit" @click="handleEdit">其他</span>
                <el-input @blur="handleBlur" ref="othernum" v-else v-model="orderInfo.quantity" min="1" maxlength="4" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
              </div>
            </div>
          </div>
          <div class="mt40 flex-align-baseline">
            <span>餐食情况</span>
            <div>{{roomInfo.breakfastState}}</div>
          </div>
          <div class="mt40 flex-align-baseline">
            <span>房费总计</span>
            <div class="price flex-align-center">
              <span>¥{{ totalAmount.toFixed(2) }}</span>
              <span class="detail pointer" @click="handleShowDetail">明细</span>
              <!-- 明细内容 -->
              <div class="price-detail-dialog scrollbar-style" v-if="showDetail">
                <div class="explain">以下价格是每日每间的房价</div>
                <div class="date-show">
                  <div class="detail-item" :class="{ 'border-r': index === showPriceArr.length - 1 || (index + 1) % 7 === 0 }" v-for="(item, index) in showPriceArr" :key="index">
                    <p class="date">{{item.date}}</p>
                    <div class="bottom">
                      <p>¥{{ item.salePrice || 0 }}</p>
                      <p>{{ index === 0 ? '无早' : item.breakfastState }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-form ref="form" :model="orderInfo" label-width="0">
        <!-- 入住信息 -->
        <div class="order-info-item flex-align-baseline">
          <div class="label">入住信息</div>
          <div class="content">
            <div class="mt40 flex-align-start">
              <span>住客姓名</span>
              <div>
                <el-form-item label="" prop="guestList" :rules="[{validator: validateGuestList, trigger: ['change', 'blur']}]">
                  <div :class="{ mb20: index !== orderInfo.guestList.length-1 }" v-for="(item, index) in orderInfo.guestList" :key="index">
                    <el-input class="w186" v-model="item.name" :placeholder="`请输入房间${index+1}住客姓名`"></el-input>
                  </div>
                </el-form-item>
                <div class="warn">
                  <img src="../../assets/images/warn.png" alt="">
                  <span>所填姓名需与入住时证件一致。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 联系人信息 -->
        <div class="order-info-item flex-align-baseline border-none">
          <div class="label">联系人信息</div>
          <div class="content">
            <div class="mt40 flex-align-start">
              <span>手机号</span>
              <div>
                <el-form-item label="" prop="contactMobile" :rules="[{validator: validateMobile, trigger: ['change', 'blur']}]">
                  <el-input class="w186" v-model="orderInfo.contactMobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <div class="warn">
                  <img src="../../assets/images/warn.png" alt="">
                  <span>请精确填写，以免无法接收信息。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 总价 -->
      <div class="buy-div">
        <span class="font12 mr10">数量</span>
        <span>共</span>
        <span class="text-green">{{orderInfo.quantity}}</span>
        <span>间</span>
        <span class="text-green">{{stayDays}}</span>
        <span>晚</span>
        <span class="ml40 font12 mr10">总价</span>
        <span class="price">¥{{ totalAmount.toFixed(2) }}</span>
        <div class="buy-btn" @click="handleBuy" v-loading.fullscreen.lock="fullscreenLoading">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/common/js/utils.js'
import { loadRoomInfo, loadBedType, loadPriceCalendar, saveOrder } from '@/api/hotel/hotelBook'
import { config } from '@/constant/config'
export default {
  data () {
    return {
      hotelInfo: {},
      roomInfo: {},
      orderInfo: {
        useStartDate: formatDate('yyyy-MM-dd', new Date()),
        useEndDate: formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000)),
        quantity: 1,
        guestList: [{ name: '' }],
        contactMobile: null
      },
      startMonth: formatDate('yyyy-MM-dd', new Date()),
      endMonth: formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000)),
      startDiasbledDateArr: [],
      endDiasbledDateArr: [],
      stayDays: 1,
      startWeek: null,
      endWeek: null,
      edit: false,
      showDetail: false,
      showPriceArr: [],
      bedTypeList: [],
      totalAmount: 0,
      disabledDateMin: null,
      disabledDateMax: null,
      moduleType: 'HOTEL',
      fullscreenLoading: false
    }
  },
  computed: {
    // 入住日期禁用
    setStartDateDisabled () {
      const that = this
      return {
        disabledDate (time) {
          if (time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000 || time.getTime() < new Date(that.disabledDateMin).getTime() - 24 * 60 * 60 * 1000 || time.getTime() > new Date(that.disabledDateMax).getTime() || that.startDiasbledDateArr.indexOf(formatDate('yyyy-MM-dd', new Date(time))) !== -1) {
            return true
          }
        }
      }
    },
    // 离店日期禁用
    setEndDateDisabled () {
      const that = this
      return {
        disabledDate (time) {
          if (time.getTime() < new Date(that.orderInfo.useStartDate).getTime() || time.getTime() < new Date(that.disabledDateMin).getTime() - 24 * 60 * 60 * 1000 || time.getTime() > new Date(that.disabledDateMax).getTime() || that.endDiasbledDateArr.indexOf(formatDate('yyyy-MM-dd', new Date(time))) !== -1) {
            return true
          }
        }
      }
    }
  },
  created () {
    this.hotelInfo = JSON.parse(this.$route.query.hotelInfo)
    this.roomId = this.$route.query.roomId
    this.loadBedType()
    this.$nextTick(() => {
      this.dealDate()
      this.loadPriceCalendar(this.orderInfo.useStartDate, this.orderInfo.useEndDate, 'stockJudge')
    })
  },
  methods: {
    dealDate () {
      this.startWeek = this.getWeekday(new Date(this.orderInfo.useStartDate).getDay())
      this.endWeek = this.getWeekday(new Date(this.orderInfo.useEndDate).getDay())
      this.stayDays = this.getDaysBetween(this.orderInfo.useStartDate, this.orderInfo.useEndDate)
      // this.startMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useStartDate))
      // this.endMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useEndDate))
    },
    validateMobile (rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入联系人手机号'))
      } else {
        let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(value)) {
          callback(new Error('联系人手机号格式不正确'))
        }
      }
      callback()
    },
    validateGuestList (rule, value, callback) {
      let nameArr = this.orderInfo.guestList.filter(val => val.name !== '')
      if (nameArr.length < this.orderInfo.guestList.length) {
        callback(new Error('请将入住信息填写完整'))
      }
      callback()
    },
    handleBuy () {
      console.log(this.orderInfo)
      const quantity = this.orderInfo.quantity
      if (quantity == null || quantity === '' || quantity < 1) {
        this.$message.warning('房间数量需大于0')
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.flag) {
            return
          }
          this.fullscreenLoading = true
          let nameArr = this.orderInfo.guestList.filter(val => val.name !== '')
          nameArr = nameArr.map(val => val.name)
          console.log(nameArr)
          const orderData = {
            tenantId: config.TENANTID,
            merchId: config.MERCHID,
            goodsId: this.roomId,
            useStartDate: this.orderInfo.useStartDate,
            useEndDate: this.orderInfo.useEndDate,
            contactMobile: this.orderInfo.contactMobile,
            occupancyQuantity: nameArr.length,
            occupants: nameArr.join(','),
            quantity: nameArr.length
          }
          saveOrder(orderData).then(res => {
            if (res.code === 0) {
              this.orderNo = res.data
              this.$router.push({
                path: '/payOrderNew',
                query: {
                  orderNo: this.orderNo,
                  moduleType: this.moduleType
                }
              })
            } else {
              this.flag = false
              this.fullscreenLoading = false
              this.$message.error(res.error)
            }
          })
        }
      })
    },
    loadRoomInfo () {
      loadRoomInfo(this.roomId).then(res => {
        if (res.code === 0) {
          res.data.relatedFacilities = this.relatedFacilitiesDeal(res.data.relatedFacilities)
          res.data.bedType = this.bedShapeInformationDeal(res.data.bedShapeInformation)
          // 图片处理  index = 1 为首图，其他为banner图
          const picList = res.data.goodsPicture ? JSON.parse(res.data.goodsPicture) : []
          res.data.bannerList = []
          picList.forEach(item => {
            if (item.index !== 1) {
              item.url.split(',').map(atem => {
                res.data.bannerList.push(atem)
              })
            }
          })
          this.roomInfo = res.data
        }
      })
    },
    loadBedType () {
      loadBedType().then(res => {
        if (res.code === 0) {
          this.bedTypeList = res.data
          this.loadRoomInfo()
        }
      })
    },
    loadPriceCalendar (useStartDate, useEndDate, stockJudge) {
      const data = {
        goodsId: this.roomId,
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        useStartDate,
        useEndDate
      }
      this.startDiasbledDateArr = []
      this.endDiasbledDateArr = []
      loadPriceCalendar(data).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.length > 0) {
            res.data.forEach((obj, index) => {
              obj.date = formatDate('MM-dd', new Date(new Date(obj.useDate)))
              if (obj.surplusStock == null || obj.surplusStock === 0) {
                this.startDiasbledDateArr.push(obj.useDate)
              }
              // 结束日期的库存要推一天
              if (index === 0 && (obj.surplusStock == null || obj.surplusStock === 0)) {
                this.endDiasbledDateArr.push(obj.useDate)
              } else if (index !== 0 && (obj.surplusStock == null || obj.surplusStock === 0) && (res.data[index - 1].surplusStock === null || res.data[index - 1].surplusStock === 0)) {
                this.endDiasbledDateArr.push(obj.useDate)
              }
            })
            this.stockDateArr = res.data
          }
          if (stockJudge === 'stockJudge') {
            this.stockJudge(useStartDate, useEndDate)
          }
        } else {
          this.$message.error(res.error)
        }
        if (this.startDateLoading) {
          this.startDateLoading.close()
        }
        if (this.endDateLoading) {
          this.endDateLoading.close()
        }
      })
    },
    stockJudge (startDate, endDate) {
      const selectDateArr = this.getBetweenDateStr(startDate, endDate)
      this.stockFlag = 0
      let i = 0
      this.showPriceArr = []
      selectDateArr.forEach((val, index) => {
        const obj = this.stockDateArr.find(v => v.useDate === val)
        this.showPriceArr.push(obj)
        if (obj && obj.surplusStock && index !== selectDateArr.length - 1) {
          i++
        }
      })
      if (i !== this.stayDays) {
        this.stockFlag = 1
        this.$message.warning('存在库存不足的日期无法下单，请重新选择')
      }
      this.calAmount()
    },
    // 价格合算
    calAmount () {
      this.totalAmount = 0
      if (this.showPriceArr.length > 0) {
        let num = 0
        this.showPriceArr.forEach((val, index) => {
          if (index !== this.showPriceArr.length - 1) {
            num = num + parseFloat(val.salePrice * this.orderInfo.quantity)
          }
        })
        this.totalAmount = num
      }
    },
    // 床型处理
    bedShapeInformationDeal (data) {
      data = JSON.parse(data)
      let bedShapeInformation = ''
      data.forEach(val => {
        const obj = this.bedTypeList.find(v => v.code === val.bedType)
        bedShapeInformation = `${bedShapeInformation},${val.bedNum}张${obj.value}`
      })
      bedShapeInformation = bedShapeInformation.substring(1)
      return bedShapeInformation
    },
    // 设施处理
    relatedFacilitiesDeal (data) {
      data = JSON.parse(data)
      const relatedFacilities = data.map(val => {
        val.valueStr = ''
        val.value.forEach(v => {
          val.valueStr = `${val.valueStr}、${v.name}`
        })
        val.valueStr = val.valueStr.substring(1)
        return val
      })
      return relatedFacilities
    },
    handleShowDetail () {
      this.showDetail = !this.showDetail
    },
    // 点击其他  房间数量
    handleEdit () {
      this.edit = true
      this.$set(this.orderInfo, 'quantity', null)
      this.$nextTick(() => {
        this.$refs.othernum.focus()
      })
    },
    handleBlur () {
      const quantity = this.orderInfo.quantity
      if (quantity == null || quantity === '' || quantity < 1) {
        this.$message.warning('房间数量需大于0')
        return
      }
      this.dealGuestList()
    },
    // 选择房间数量
    handleRoomNum (quantity) {
      this.edit = false
      this.$set(this.orderInfo, 'quantity', quantity)
      this.dealGuestList()
    },
    // 住客数组处理
    dealGuestList () {
      const quantity = this.orderInfo.quantity
      const guestList = JSON.parse(JSON.stringify(this.orderInfo.guestList))
      for (let i = 0; i < quantity; i++) {
        if (guestList[i] == null) {
          guestList.push({ name: '' })
        }
      }
      guestList.length = quantity
      this.$set(this.orderInfo, 'guestList', guestList)
      this.calAmount()
    },
    // 选择入住日期
    handleStartDate (date) {
      // 如果离店日期小于入住日期 自动将离店日期变为入住日期后一天
      if (new Date(date).getTime() >= new Date(this.orderInfo.useEndDate).getTime()) {
        const useEndDate = formatDate('yyyy-MM-dd', new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000))
        this.$set(this.orderInfo, 'useEndDate', useEndDate)
        this.endMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useEndDate))
      }
      this.dealDate()
      this.startMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useStartDate))
      this.loadPriceCalendar(this.startMonth, this.orderInfo.useEndDate, 'stockJudge')
    },
    // 选择离店日期
    handleEndDate (date) {
      this.dealDate()
      this.endMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useEndDate))
      this.loadPriceCalendar(this.orderInfo.useStartDate, this.endMonth, 'stockJudge')
    },
    getWeekday (day) {
      return ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][day]
    },
    // 获取两个日期相差天数
    getDaysBetween (start, end) {
      const startDate = Date.parse(start)
      const endDate = Date.parse(end)
      return (endDate - startDate) / (86400 * 1000)
    },
    // 获取两个日期之间的日期
    getBetweenDateStr (stime, etime) {
    // 初始化日期列表，数组
      var diffdate = []
      var i = 0
      // 开始日期小于等于结束日期,并循环
      while (stime <= etime) {
        diffdate[i] = stime
        // 获取开始日期时间戳
        var stimeTs = new Date(stime).getTime()
        // 增加一天时间戳后的日期
        var nextDate = stimeTs + (24 * 60 * 60 * 1000)
        // 拼接年月日，这里的月份会返回（0-11），所以要+1
        var nextDatesY = new Date(nextDate).getFullYear() + '-'
        var nextDatesM = (new Date(nextDate).getMonth() + 1 < 10) ? '0' + (new Date(nextDate).getMonth() + 1) + '-' : (new Date(nextDate).getMonth() + 1) + '-'
        var nextDatesD = (new Date(nextDate).getDate() < 10) ? '0' + new Date(nextDate).getDate() : new Date(nextDate).getDate()

        stime = nextDatesY + nextDatesM + nextDatesD

        // 增加数组key
        i++
      }
      return diffdate
    },
    handleShowDate (date) {
      this.dateType = date
      this.$refs[date].focus()
      // 加载当前月的库存
      let nowDate = date === 'startDate' ? this.startMonth : this.endMonth
      this.getDateToLoadPriceCalendar(nowDate)
      // 监听切换月份键
      if (!this.listenStart && date === 'startDate') {
        this.listenStartMonth()
        this.listenStart = true
      }
      if (!this.listenEnd && date === 'endDate') {
        this.listenEndMonth()
        this.listenEnd = true
      }
    },
    getDateToLoadPriceCalendar (nowDate) {
      this.$nextTick(() => {
        if (this.dateType === 'startDate') {
          this.startDateLoading = this.$loading({
            lock: true,
            text: '请稍等',
            backgroundColor: 'rgba(55,55,55,0.4)',
            spinner: 'el-icon-loading',
            target: document.querySelector('.start-date .el-picker-panel__content')
          })
        } else {
          this.endDateLoading = this.$loading({
            lock: true,
            text: '请稍等',
            backgroundColor: 'rgba(55,55,55,0.4)',
            spinner: 'el-icon-loading',
            target: document.querySelector('.end-date .el-picker-panel__content')
          })
        }
      })
      const dateObj = this.getDateByMonth(new Date(nowDate).getTime())
      // 如果是当前月则startDate为当天
      const nowMonth = new Date().getMonth() + 1 // 当前月
      if (parseInt(nowMonth) === parseInt(formatDate('MM', new Date(nowDate)))) {
        dateObj.startDate = formatDate('yyyy-MM-dd', new Date())
      }
      this.disabledDateMin = dateObj.startDate
      this.disabledDateMax = dateObj.endDate
      this.loadPriceCalendar(dateObj.startDate, dateObj.endDate)
    },
    // 获取某月第一天和最后一天
    getDateByMonth (timeStamp) {
      let inDate = new Date(timeStamp)
      let year = inDate.getFullYear()
      let month = inDate.getMonth()
      let startTime = new Date(year, month, 1).getTime()
      let endTime = new Date(year, month + 1, 0).getTime()
      return {
        startDate: formatDate('yyyy-MM-dd', new Date(startTime)),
        endDate: formatDate('yyyy-MM-dd', new Date(endTime))
      }
    },
    listenStartMonth () {
      this.$nextTick(() => {
        // 点击前一个月
        const startDateLeft = document.querySelector('.start-date .el-icon-arrow-left')
        startDateLeft.addEventListener('click', () => {
          const nowDate = this.getBeforeMonth(this.startMonth)
          this.startMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
        // 点击后一个月
        const startDateRight = document.querySelector('.start-date .el-icon-arrow-right')
        startDateRight.addEventListener('click', () => {
          const nowDate = this.getNextMonth(this.startMonth)
          this.startMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
      })
    },
    listenEndMonth () {
      this.$nextTick(() => {
        const endDateLeft = document.querySelector('.end-date .el-icon-arrow-left')
        endDateLeft.addEventListener('click', () => {
          const nowDate = this.getBeforeMonth(this.endMonth)
          this.endMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
        const endDateRight = document.querySelector('.end-date .el-icon-arrow-right')
        endDateRight.addEventListener('click', () => {
          const nowDate = this.getNextMonth(this.endMonth)
          this.endMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
      })
    },
    // 获取上一个月
    getBeforeMonth (date) {
      var now = new Date(date)
      var ds = new Date(now.setMonth(now.getMonth() - 1))
      var year = ds.getFullYear()
      var mon = ds.getMonth() + 1
      var day = ds.getDate()
      var s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
      return s
    },
    // 获取下一个月
    getNextMonth (date) {
      var now = new Date(date)
      var ds = new Date(now.setMonth(now.getMonth() + 1))
      var year = ds.getFullYear()
      var mon = ds.getMonth() + 1
      var day = ds.getDate()
      var s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
      return s
    }
  }
}
</script>
<style lang="scss">
.start-date .el-icon-d-arrow-left, .start-date .el-icon-d-arrow-right, .end-date .el-icon-d-arrow-left, .end-date .el-icon-d-arrow-right {
  display: none;
}
</style>
<style scoped lang='scss'>
.hotel-book{
  background-color: #F5F6F9;
  overflow: hidden;
  .room-info-outter{
    max-width: 1279px;
    overflow-x: auto;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 30px 40px 40px;
    background-color: #fff;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    .title{
      font-size: 24px;
      font-weight: bold;
      color: #9B232A;
      padding-bottom: 30px;
    }
    .content{
      .left{
        width: 723px;
        height: 417px;
        img{
          width: 100%;
          height: 100%;
        }
        /deep/.el-carousel__container {
          width: 723px;
          height: 417px;
          .el-carousel__item {
            width: 100%;
            height: 100%;
          }
          .el-carousel__arrow {
            border-radius: 0;
          }
        }
        /deep/.el-carousel__arrow--left {
          width: 39px;
          height: 78px;
          background: url('../../assets/images/hotelManage/leftBanner.webp');
        }
        /deep/.el-carousel__arrow--right {
          width: 39px;
          height: 78px;
          background: url('../../assets/images/hotelManage/rightBanner.webp');
        }
      }
      .right{
        margin-left: 40px;
        .hotel-info{
          .flex-start{
            display: flex;
            align-items: flex-start;
          }
          .hotel-name{
            font-size: 32px;
            font-weight: bold;
            color: #242B34;
          }
          .hotel-type{
            margin-left: 10px;
            background: #F0BD5D;
            border-radius: 2px;
            padding: 4px 10px;
            font-size: 12px;
            color: #FFFFFF;
          }
          .hotel-adr{
            display: flex;
            margin-top: 8px;
            img{
              width: 20px;
              height: 20px;
              margin-right: 4px;
            }
            span{
              font-size: 14px;
              color: #44516F;
              line-height: 20px;
            }
          }
        }
        .room-info{
          margin-top: 40px;
          .room-name{
            font-size: 24px;
            font-weight: bold;
            line-height: 36px;
            color: #9B232A;
          }
          .facility{
            .block{
              display: flex;
              div{
                display: flex;
                // align-items: center;
                width: 108px;
              }
              img{
                width: 20px;
                height: 20px;
                margin-right: 8px;
              }
              span{
                font-size: 14px;
                line-height: 20px;
                color: #44516F;
              }
            }
            .mt8{
              margin-top: 8px;
            }
          }
        }
        .facility-info{
          margin-top: 20px;
          .facility-name{
            font-size: 14px;
            color: #242B34;
            margin-right: 20px;
            width: 70px;
            text-align: justify;
            height: 10px;
          }
          .facility-name::after{
            content: '';
            display: inline-block;
            padding-left: 100%;
          }
          .facility-detail{
            font-size: 14px;
            line-height: 22px;
            color: #44516F;
            opacity: 0.91;
          }

        }
      }
    }
  }
  .order-info{
    max-width: 1279px;
    overflow-x: auto;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    margin: 40px auto;
    padding: 30px 40px 40px;
    .flex-align-start{
      display: flex;
      align-items: flex-start;
    }
    .title{
      font-size: 24px;
      font-weight: bold;
      color: #9B232A;
    }
    .order-info-item{
      padding-bottom: 30px;
      border-bottom: 1px solid #8FA8BC;
      .label{
        font-size: 18px;
        font-weight: bold;
        color: #242B34;
        margin-right: 80px;
      }
      .content{
        .mt40{
          margin-top: 40px;
          .m16{
            margin: 0 16px;
          }
          .staydays{
            font-size: 16px;
            color: #9B232A;
            margin-left: 20px;
          }
          >span{
            font-size: 16px;
            color: #1D263A;
            margin-right: 40px;
          }
          .date-div{
            .date-info{
              border: 1px solid #95A3AF;
              opacity: 1;
              border-radius: 4px;
              padding: 8px 16px;
              display: flex;
              align-items: flex-end;
              position: relative;
              img{
                width: 16px;
                height: 16px;
                margin-left: 8px;
              }
              span{
                font-size: 14px;
                color: #95A3AF;
              }
              .date{
                font-size: 16px;
                color: #242B34;
                margin: 0 20px;
              }
              .hide-date {
                position: absolute;
                z-index: -100;
                left: 0;
                top: 0;
              }
            }

          }
          .warn{
            font-size: 14px;
            color: #44516F;
            display: flex;
            align-items: center;
            img{
              width: 16px;
              height: 16px;
              margin-right: 8px;
            }
          }
          /deep/.w186 .el-input__inner{
            width: 186px;
          }
        }
        .room-num{
          display: flex;
          align-items: center;
          .active{
            border: 1px solid #9B232A;
          }
          .num-div{
            width: 64px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border: 1px solid #95A3AF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: bold;
            color: #1D263A;
            margin-right: 20px;
            display: inline-block;
            cursor: pointer;
            position: relative;
            img{
              width: 18px;
              height: 18px;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
          .other{
            background: #9B232A;
            font-size: 16px;
            color: #FFFFFF;
            /deep/.el-input__inner{
              border: none;
              background: unset;
              text-align: center;
              color: #fff;
              font-size: 16px;
            }
          }
        }
        .price{
          font-size: 22px;
          color: #FF4400;
          position: relative;
          .detail{
            font-size: 14px;
            color: #9B232A;
            margin-left: 12px;
          }
          /*滚动条样式*/
          .scrollbar-style::-webkit-scrollbar {
              width: 4px;
              /*height: 4px;*/
          }
          .scrollbar-style::-webkit-scrollbar-thumb {
              border-radius: 10px;
              -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
              background: #9B232A;
          }
          .scrollbar-style::-webkit-scrollbar-track {
              -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
              border-radius: 0;
              background: #dadde0d7;
          }
          .price-detail-dialog{
            position: absolute;
            // width: 746px;
            // box-sizing: border-box;
            // min-height: 300px;
            z-index: 100;
            top: 30px;
            left: 20px;
            padding: 20px;
            background: #fff;
            box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.16);
            max-height: 400px;
            overflow-y: auto;
            .explain{
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              color: #95A3AF;
            }
            .border-r{
              border-right: 1px solid #EBECF2 !important;
            }
            .date-show{
              display: grid;
              grid-template-columns: 104px 104px 104px 104px 104px 104px 104px;
            }
            .detail-item{
              margin-top: 12px;
              float: left;
              border: 1px solid #EBECF2;
              border-right: none;
              .date{
                // width: 104px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #ECF5FF;
                font-size: 16px;
                font-weight: 400;
                color: #6A7792;
              }
              .bottom{
                height: 75px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                p:nth-child(1) {
                  font-size: 20px;
                  font-weight: 400;
                  color: #FF4400;
                }
                p:nth-child(2) {
                  font-size: 14px;
                  font-weight: 400;
                  color: #1D263A;
                  margin-top: 8px;
                }
              }
            }
          }
        }

      }
    }
    .border-none{
      border-bottom: none;
    }
  }
  .buy-div{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 86px;
    span{
      font-size: 20px;
      font-weight: bold;
      color: #424855;
      margin-right: 2px;
    }
    .font12{
      font-weight: 400;
      font-size: 12px;
      color: #687280;
      margin-right: 10px;
    }
    .ml40{
      margin-left: 40px;
    }
    .price{
      color: #FF4400;
    }
    .buy-btn{
      width: 140px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #9B232A;
      opacity: 1;
      border-radius: 4px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      margin-left: 30px;
      cursor: pointer;
    }
  }
}
</style>
